(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qo-caffeine-clock"] && !Shopify.designMode) return;
  try {
    
(function(){
  "use strict";

  var ICONS = {
    cup: '<path d="M5 9h11v5a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V9Z"/><path d="M16 10h1.5a2.5 2.5 0 0 1 0 5H16"/><path d="M3 20h14"/><path d="M8 4c.5 1-.5 1.5 0 2.5M12 4c.5 1-.5 1.5 0 2.5"/>',
    mug: '<path d="M6 8h9l-1 10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 8Z"/><path d="M15 10h1.5a2 2 0 1 1 0 4H15"/><path d="M9 4c.4.8-.4 1.2 0 2M13 4c.4.8-.4 1.2 0 2"/>',
    glass: '<path d="M7 4h10l-1.2 15.2A2 2 0 0 1 13.8 21h-3.6a2 2 0 0 1-2-1.8L7 4Z"/><rect x="9.3" y="9" width="3" height="3" rx="0.6"/><rect x="12.3" y="13" width="3" height="3" rx="0.6"/>',
    teacup: '<path d="M4 9h12v4a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9Z"/><path d="M16 10h1.2a2 2 0 1 1 0 4H16"/><path d="M2 20h16"/><path d="M10 9V6l2-1.5"/><rect x="11" y="3" width="2.4" height="1.6" rx="0.3"/>',
    bowl: '<path d="M4 11h16a8 8 0 0 1-8 8 8 8 0 0 1-8-8Z"/><path d="M12 11V5"/><path d="M9 5.5 12 3l3 2.5M9 8l3-2 3 2"/>',
    can: '<rect x="7" y="3" width="10" height="18" rx="3"/><path d="M13 7l-3 6h3l-1 5 4-7h-3l0-4Z" fill="currentColor" stroke="none"/>',
    leaf: '<path d="M12 3c4 2 7 6 7 10a7 7 0 0 1-14 0c0-4 3-8 7-10Z"/><path d="M12 21V9"/>',
    choc: '<rect x="4" y="4" width="16" height="16" rx="2"/><path d="M12 4v16M4 12h16"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    drop: '<path d="M12 3c3 4 6 8 6 12a6 6 0 0 1-12 0c0-4 3-8 6-12Z"/>'
  };
  function iconSvg(name){
    return '<svg class="icon" viewBox="0 0 24 24">'+(ICONS[name]||ICONS.drop)+'</svg>';
  }

  // mode: "fixed" (flat mg), "oz" (mg = oz * mgPerOz), "gram" (mg = g * mgPerGram), "custom"
  var GROUPS = [
    { label:"Coffee", options:[
      {name:"Espresso", icon:"cup", cat:"coffee", mode:"oz", mgPerOz:65, defaultQty:1},
      {name:"Drip coffee", icon:"mug", cat:"coffee", mode:"oz", mgPerOz:12, defaultQty:8},
      {name:"Cold brew", icon:"glass", cat:"coffee", mode:"oz", mgPerOz:14, defaultQty:12}
    ]},
    { label:"Tea", options:[
      {name:"Black tea (8oz)", icon:"teacup", cat:"tea", mode:"fixed", mg:47},
      {name:"Green tea (8oz)", icon:"teacup", cat:"tea", mode:"fixed", mg:28},
      {name:"Low‑caf tea", icon:"leaf", cat:"lowcaf", mode:"fixed", mg:5}
    ]},
    { label:"Matcha & hojicha", options:[
      {name:"Matcha", icon:"bowl", cat:"matcha", mode:"gram", mgPerGram:30, defaultQty:2},
      {name:"Hojicha", icon:"bowl", cat:"hojicha", mode:"gram", mgPerGram:7, defaultQty:2}
    ]},
    { label:"Energy & soda", options:[
      {name:"Energy drink, std", icon:"can", cat:"energy", mode:"fixed", mg:80},
      {name:"Energy drink, large", icon:"can", cat:"energy", mode:"fixed", mg:160},
      {name:"Cola (12oz)", icon:"can", cat:"energy", mode:"fixed", mg:34}
    ]},
    { label:"Other", options:[
      {name:"Dark chocolate (1oz)", icon:"choc", cat:"choc", mode:"fixed", mg:20},
      {name:"Custom…", icon:"plus", cat:"custom", mode:"custom"}
    ]}
  ];

  var STORE_KEY = "caffeineClockV1";
  var state = { drinks: [], profile: { metab:"average", weight:null, weightUnit:"lb", pregnant:false }, threshold:50, bedtime:"23:00" };

  function loadState(){
    try{
      var raw = localStorage.getItem(STORE_KEY);
      if(!raw) return;
      var parsed = JSON.parse(raw);
      if(!parsed || !Array.isArray(parsed.drinks)) return;
      var cutoff = Date.now() - 30*3600*1000;
      parsed.drinks = parsed.drinks.filter(function(d){ return d.time > cutoff; });
      state = Object.assign(state, parsed);
    }catch(e){}
  }
  function saveState(){
    try{ localStorage.setItem(STORE_KEY, JSON.stringify(state)); }catch(e){}
  }

  function halfLifeHours(profile){
    var base = 5;
    if(profile.metab === "fast") base = 3;
    else if(profile.metab === "slow") base = 7;
    if(profile.pregnant) base = base * 1.9;
    return base;
  }

  function levelAt(t, drinks, hl){
    var total = 0;
    for(var i=0;i<drinks.length;i++){
      var d = drinks[i];
      if(t < d.time) continue;
      var hrs = (t - d.time) / 3600000;
      total += d.mg * Math.pow(0.5, hrs / hl);
    }
    return total;
  }

  function fmtTime(ts){
    var d = new Date(ts);
    var h = d.getHours(), m = d.getMinutes();
    var ap = h >= 12 ? "PM" : "AM";
    var h12 = h % 12; if(h12 === 0) h12 = 12;
    return h12 + ":" + (m<10?"0":"") + m + " " + ap;
  }
  function todayAt(hhmm){
    var parts = hhmm.split(":");
    var d = new Date();
    d.setHours(+parts[0], +parts[1], 0, 0);
    return d.getTime();
  }

  // ---------- "when" selector ----------
  var pendingOffset = 0;
  var customTimeInput = document.getElementById("ccCustomTimeInput");
  var whenPreview = document.getElementById("ccWhenPreview");
  var whenChips = document.getElementById("ccWhenChips");

  function getPendingTimestamp(){
    if(pendingOffset === "custom"){
      return todayAt(customTimeInput.value || "12:00");
    }
    return Date.now() - pendingOffset*60000;
  }
  function updateWhenPreview(){
    whenPreview.textContent = pendingOffset === 0 ? "Now" : "→ " + fmtTime(getPendingTimestamp());
  }
  whenChips.addEventListener("click", function(e){
    var btn = e.target.closest(".chip");
    if(!btn) return;
    Array.prototype.forEach.call(whenChips.querySelectorAll(".chip"), function(c){ c.classList.remove("active"); });
    btn.classList.add("active");
    var off = btn.getAttribute("data-off");
    pendingOffset = off === "custom" ? "custom" : parseInt(off,10);
    customTimeInput.style.display = pendingOffset === "custom" ? "" : "none";
    if(pendingOffset === "custom" && !customTimeInput.value){
      var now = new Date();
      customTimeInput.value = (now.getHours()+"").padStart(2,"0")+":"+(now.getMinutes()+"").padStart(2,"0");
    }
    updateWhenPreview();
  });
  customTimeInput.addEventListener("input", updateWhenPreview);
  function resetWhenSelector(){
    pendingOffset = 0;
    customTimeInput.style.display = "none";
    Array.prototype.forEach.call(whenChips.querySelectorAll(".chip"), function(c){ c.classList.remove("active"); });
    whenChips.querySelector('[data-off="0"]').classList.add("active");
    updateWhenPreview();
  }

  // ---------- drink option selection ----------
  var drinkGroupsEl = document.getElementById("ccDrinkGroups");
  var ozBox = document.getElementById("ccOzBox");
  var gramBox = document.getElementById("ccGramBox");
  var customBox = document.getElementById("ccCustomBox");
  var ozInput = document.getElementById("ccOzInput");
  var ozPreview = document.getElementById("ccOzPreview");
  var gramInput = document.getElementById("ccGramInput");
  var gramPreview = document.getElementById("ccGramPreview");
  var cNameInput = document.getElementById("ccName");
  var cMgInput = document.getElementById("ccMg");
  var logDrinkBtn = document.getElementById("ccLogDrinkBtn");
  var selectedOption = null;
  var allQbtns = [];

  GROUPS.forEach(function(group){
    var wrap = document.createElement("div");
    wrap.className = "optgroup";
    var label = document.createElement("div");
    label.className = "optgroup-label";
    label.textContent = group.label;
    var grid = document.createElement("div");
    grid.className = "optiongrid";
    group.options.forEach(function(p){
      var b = document.createElement("button");
      b.type = "button";
      b.className = "qbtn";
      var sub = p.mode === "fixed" ? p.mg+" mg" : p.mode === "oz" ? "Enter oz" : p.mode === "gram" ? "Enter grams" : "Type your own";
      b.innerHTML = '<span class="tile tile-'+p.cat+'">'+iconSvg(p.icon)+'</span>'+
        '<span class="qtext"><span class="qname">'+p.name+'</span><span class="qmg">'+sub+'</span></span>';
      b.addEventListener("click", function(){ selectOption(p, b); });
      grid.appendChild(b);
      allQbtns.push(b);
    });
    wrap.appendChild(label);
    wrap.appendChild(grid);
    drinkGroupsEl.appendChild(wrap);
  });

  function selectOption(p, btnEl){
    if(selectedOption === p){
      selectedOption = null;
      btnEl.classList.remove("selected");
    } else {
      allQbtns.forEach(function(el){ el.classList.remove("selected"); });
      btnEl.classList.add("selected");
      selectedOption = p;
    }
    ozBox.classList.remove("show");
    gramBox.classList.remove("show");
    customBox.classList.remove("show");
    if(selectedOption){
      if(selectedOption.mode === "oz"){
        ozBox.classList.add("show");
        ozInput.value = selectedOption.defaultQty;
        updateOzPreview();
      } else if(selectedOption.mode === "gram"){
        gramBox.classList.add("show");
        gramInput.value = selectedOption.defaultQty;
        updateGramPreview();
      } else if(selectedOption.mode === "custom"){
        customBox.classList.add("show");
      }
    }
    updateLogButtonState();
  }

  function updateOzPreview(){
    if(!selectedOption || selectedOption.mode !== "oz") return;
    var oz = parseFloat(ozInput.value);
    ozPreview.textContent = (!isNaN(oz) && oz > 0) ? "≈ " + Math.round(oz*selectedOption.mgPerOz) + " mg" : "";
  }
  function updateGramPreview(){
    if(!selectedOption || selectedOption.mode !== "gram") return;
    var g = parseFloat(gramInput.value);
    gramPreview.textContent = (!isNaN(g) && g > 0) ? "≈ " + Math.round(g*selectedOption.mgPerGram) + " mg" : "";
  }
  ozInput.addEventListener("input", function(){ updateOzPreview(); updateLogButtonState(); });
  gramInput.addEventListener("input", function(){ updateGramPreview(); updateLogButtonState(); });
  cNameInput.addEventListener("input", updateLogButtonState);
  cMgInput.addEventListener("input", updateLogButtonState);

  function updateLogButtonState(){
    var ok = false;
    if(!selectedOption){ ok = false; }
    else if(selectedOption.mode === "fixed"){ ok = true; }
    else if(selectedOption.mode === "oz"){ var oz = parseFloat(ozInput.value); ok = !isNaN(oz) && oz > 0; }
    else if(selectedOption.mode === "gram"){ var g = parseFloat(gramInput.value); ok = !isNaN(g) && g > 0; }
    else if(selectedOption.mode === "custom"){
      var mg = parseFloat(cMgInput.value);
      ok = cNameInput.value.trim().length > 0 && !isNaN(mg) && mg >= 0;
    }
    logDrinkBtn.disabled = !ok;
  }

  logDrinkBtn.addEventListener("click", function(){
    if(!selectedOption) return;
    var time = getPendingTimestamp();
    var p = selectedOption;
    if(p.mode === "fixed"){
      addDrink(p.name, p.mg, time, p.icon, p.cat);
    } else if(p.mode === "oz"){
      var oz = parseFloat(ozInput.value);
      if(isNaN(oz) || oz <= 0) return;
      addDrink(p.name+" ("+oz+"oz)", Math.round(oz*p.mgPerOz), time, p.icon, p.cat);
    } else if(p.mode === "gram"){
      var g = parseFloat(gramInput.value);
      if(isNaN(g) || g <= 0) return;
      addDrink(p.name+" ("+g+"g)", Math.round(g*p.mgPerGram), time, p.icon, p.cat);
    } else if(p.mode === "custom"){
      var name = cNameInput.value.trim();
      var mg = parseFloat(cMgInput.value);
      if(!name || isNaN(mg) || mg < 0) return;
      addDrink(name, mg, time, "drop", "custom");
      cNameInput.value = ""; cMgInput.value = "";
    }
    allQbtns.forEach(function(el){ el.classList.remove("selected"); });
    ozBox.classList.remove("show");
    gramBox.classList.remove("show");
    customBox.classList.remove("show");
    selectedOption = null;
    resetWhenSelector();
    updateLogButtonState();
    var old = logDrinkBtn.textContent;
    logDrinkBtn.textContent = "Logged ✓";
    setTimeout(function(){ logDrinkBtn.textContent = old; }, 1200);
  });

  function addDrink(name, mg, time, icon, cat){
    state.drinks.push({ id: Date.now()+"_"+Math.random().toString(36).slice(2), name:name, mg:mg, time:time, icon:icon||"drop", cat:cat||"custom" });
    state.drinks.sort(function(a,b){ return a.time - b.time; });
    saveState();
    renderAll();
  }
  function removeDrink(id){
    state.drinks = state.drinks.filter(function(d){ return d.id !== id; });
    saveState();
    renderAll();
  }

  // ---------- profile controls ----------
  var metabSelect = document.getElementById("ccMetabSelect");
  var weightInput = document.getElementById("ccWeightInput");
  var weightUnit = document.getElementById("ccWeightUnit");
  var pregnantCheck = document.getElementById("ccPregnantCheck");
  var bedtimeInput = document.getElementById("ccBedtimeInput");
  var thresholdSlider = document.getElementById("ccThresholdSlider");
  var thresholdVal = document.getElementById("ccThresholdVal");

  function syncControlsFromState(){
    metabSelect.value = state.profile.metab;
    if(state.profile.weight) weightInput.value = state.profile.weight;
    weightUnit.value = state.profile.weightUnit;
    pregnantCheck.checked = state.profile.pregnant;
    bedtimeInput.value = state.bedtime;
    thresholdSlider.value = state.threshold;
    thresholdVal.textContent = state.threshold + " mg";
  }

  metabSelect.addEventListener("change", function(){ state.profile.metab = metabSelect.value; saveState(); renderAll(); });
  weightInput.addEventListener("input", function(){ state.profile.weight = parseFloat(weightInput.value)||null; saveState(); renderAll(); });
  weightUnit.addEventListener("change", function(){ state.profile.weightUnit = weightUnit.value; saveState(); renderAll(); });
  pregnantCheck.addEventListener("change", function(){ state.profile.pregnant = pregnantCheck.checked; saveState(); renderAll(); });
  bedtimeInput.addEventListener("change", function(){ state.bedtime = bedtimeInput.value; saveState(); renderAll(); });
  thresholdSlider.addEventListener("input", function(){ state.threshold = +thresholdSlider.value; thresholdVal.textContent = state.threshold+" mg"; saveState(); renderAll(); });

  document.getElementById("ccResetBtn").addEventListener("click", function(){
    state.drinks = [];
    saveState();
    renderAll();
  });

  // ---------- gauge ----------
  var gaugeArc = document.getElementById("ccGaugeArc");
  var GAUGE_CIRC = 2 * Math.PI * 82;
  gaugeArc.setAttribute("stroke-dasharray", GAUGE_CIRC.toFixed(1));

  function statusFor(current, threshold, peak){
    if(current <= threshold) return "clear";
    if(peak > 0 && current >= peak*0.75) return "wired";
    return "winding";
  }
  var statusColor = { wired:"var(--rust)", winding:"var(--ochre)", clear:"var(--blue-deep)" };
  var statusLabelText = { wired:"Wired", winding:"Winding down", clear:"Clear" };

  function renderGauge(current, peak, status){
    var frac = peak > 0 ? Math.max(0, Math.min(1, current/peak)) : 0;
    var offset = GAUGE_CIRC * (1 - frac);
    gaugeArc.setAttribute("stroke-dashoffset", offset.toFixed(1));
    gaugeArc.style.stroke = statusColor[status];
    gaugeArc.style.setProperty("--glow-color", statusColor[status]);
    document.getElementById("ccGaugeMg").textContent = Math.round(current);
    var pill = document.getElementById("ccStatusPill");
    pill.className = "pill " + status;
    document.getElementById("ccStatusLabel").textContent = statusLabelText[status];
  }

  // ---------- chart ----------
  var chartSvg = document.getElementById("ccChartSvg");
  var tooltip = document.getElementById("ccChartTooltip");
  var CW = 720, CH = 300, PAD_L = 42, PAD_R = 16, PAD_T = 18, PAD_B = 34;

  function buildCurveData(){
    var now = Date.now();
    var earliest = state.drinks.length ? state.drinks[0].time : now - 3600000;
    var bedtimeMs = todayAt(state.bedtime);
    if(bedtimeMs < now) bedtimeMs += 24*3600000;
    var winStart = Math.min(now - 3600000, earliest - 1800000);
    var winEnd = Math.max(now + 12*3600000, bedtimeMs + 2*3600000);
    winEnd = Math.min(winEnd, winStart + 30*3600000);
    var hl = halfLifeHours(state.profile);
    var steps = 120;
    var pts = [];
    for(var i=0;i<=steps;i++){
      var t = winStart + (winEnd-winStart)*(i/steps);
      pts.push({ t:t, mg: levelAt(t, state.drinks, hl) });
    }
    return { pts:pts, winStart:winStart, winEnd:winEnd, now:now, bedtimeMs:bedtimeMs, hl:hl };
  }

  function svgEl(tag, attrs){
    var el = document.createElementNS("http://www.w3.org/2000/svg", tag);
    for(var k in attrs) el.setAttribute(k, attrs[k]);
    return el;
  }

  function renderChart(data, maxMg){
    chartSvg.innerHTML = "";
    var x = function(t){ return PAD_L + (t - data.winStart) / (data.winEnd - data.winStart) * (CW - PAD_L - PAD_R); };
    var yMax = Math.max(maxMg * 1.15, state.threshold * 1.4, 40);
    var y = function(mg){ return PAD_T + (1 - mg/yMax) * (CH - PAD_T - PAD_B); };

    var ticksY = 4;
    for(var i=0;i<=ticksY;i++){
      var val = yMax * i / ticksY;
      var yy = y(val);
      chartSvg.appendChild(svgEl("line",{x1:PAD_L,x2:CW-PAD_R,y1:yy,y2:yy,stroke:"var(--border-soft)","stroke-width":1}));
      chartSvg.appendChild(svgEl("text",{x:PAD_L-8,y:yy+4,"text-anchor":"end","font-size":10,fill:"var(--text-faint)","font-family":"IBM Plex Mono, monospace"})).textContent = Math.round(val);
    }
    var hourStep = 4*3600000;
    var startHour = Math.ceil(data.winStart/hourStep)*hourStep;
    for(var t=startHour; t<=data.winEnd; t+=hourStep){
      var xx = x(t);
      chartSvg.appendChild(svgEl("text",{x:xx,y:CH-PAD_B+18,"text-anchor":"middle","font-size":10,fill:"var(--text-faint)","font-family":"IBM Plex Mono, monospace"})).textContent = fmtTime(t).replace(" ","");
    }

    var thY = y(state.threshold);
    var thLine = svgEl("line",{x1:PAD_L,x2:CW-PAD_R,y1:thY,y2:thY,stroke:"var(--ochre)","stroke-width":1.5,"stroke-dasharray":"5,5",opacity:.8});
    chartSvg.appendChild(thLine);

    var pathTop = "M " + data.pts.map(function(p){ return x(p.t)+","+y(p.mg); }).join(" L ");
    var areaPath = pathTop + " L " + x(data.pts[data.pts.length-1].t) + "," + y(0) + " L " + x(data.pts[0].t) + "," + y(0) + " Z";
    var gradId = "ccGcGrad";
    var defs = svgEl("defs",{});
    var grad = svgEl("linearGradient",{id:gradId,x1:0,y1:0,x2:0,y2:1});
    grad.appendChild(svgEl("stop",{offset:"0%","stop-color":"var(--blue-solid)","stop-opacity":.26}));
    grad.appendChild(svgEl("stop",{offset:"100%","stop-color":"var(--blue-solid)","stop-opacity":.02}));
    defs.appendChild(grad);
    chartSvg.appendChild(defs);
    chartSvg.appendChild(svgEl("path",{d:areaPath, fill:"url(#"+gradId+")", stroke:"none"}));
    chartSvg.appendChild(svgEl("path",{d:pathTop, fill:"none", stroke:"var(--blue-solid)","stroke-width":2.5,"stroke-linecap":"round","stroke-linejoin":"round"}));

    state.drinks.forEach(function(d){
      if(d.time < data.winStart || d.time > data.winEnd) return;
      var mgAtDose = levelAt(d.time+1, state.drinks, data.hl);
      chartSvg.appendChild(svgEl("circle",{cx:x(d.time), cy:y(mgAtDose), r:4.5, fill:"var(--surface)", stroke:"var(--blue-solid)","stroke-width":2}));
    });

    var nowX = x(data.now);
    chartSvg.appendChild(svgEl("line",{x1:nowX,x2:nowX,y1:PAD_T,y2:CH-PAD_B,stroke:"var(--text-dim)","stroke-width":1.5,"stroke-dasharray":"3,4"}));
    chartSvg.appendChild(svgEl("text",{x:nowX,y:PAD_T-6,"text-anchor":"middle","font-size":10,fill:"var(--text-dim)","font-family":"IBM Plex Mono, monospace","font-weight":600})).textContent = "now";

    var hoverLine = svgEl("line",{x1:0,x2:0,y1:PAD_T,y2:CH-PAD_B,stroke:"var(--text)","stroke-width":1,opacity:0});
    var hoverDot = svgEl("circle",{r:4,fill:"var(--blue-solid)",opacity:0});
    chartSvg.appendChild(hoverLine);
    chartSvg.appendChild(hoverDot);
    var hitRect = svgEl("rect",{x:PAD_L,y:PAD_T,width:CW-PAD_L-PAD_R,height:CH-PAD_T-PAD_B,fill:"transparent"});
    chartSvg.appendChild(hitRect);

    function pointFromEvent(evt){
      var rect = chartSvg.getBoundingClientRect();
      var svgX = (evt.clientX - rect.left) / rect.width * CW;
      var frac = Math.max(0, Math.min(1, (svgX - PAD_L)/(CW-PAD_L-PAD_R)));
      var t = data.winStart + frac*(data.winEnd - data.winStart);
      var mg = levelAt(t, state.drinks, data.hl);
      return { t:t, mg:mg, x:x(t), y:y(mg) };
    }
    hitRect.addEventListener("mousemove", function(evt){
      var p = pointFromEvent(evt);
      hoverLine.setAttribute("x1",p.x); hoverLine.setAttribute("x2",p.x); hoverLine.setAttribute("opacity",0.5);
      hoverDot.setAttribute("cx",p.x); hoverDot.setAttribute("cy",p.y); hoverDot.setAttribute("opacity",1);
      var wrapRect = chartSvg.parentElement.getBoundingClientRect();
      var px = (p.x/CW)*wrapRect.width;
      var py = (p.y/CH)*wrapRect.height;
      tooltip.style.left = px+"px"; tooltip.style.top = py+"px"; tooltip.style.opacity = 1;
      tooltip.innerHTML = fmtTime(p.t) + " — <b>" + Math.round(p.mg) + " mg</b>";
    });
    hitRect.addEventListener("mouseleave", function(){
      hoverLine.setAttribute("opacity",0); hoverDot.setAttribute("opacity",0); tooltip.style.opacity = 0;
    });
  }

  // ---------- log list ----------
  function renderLog(){
    var list = document.getElementById("ccLogList");
    list.innerHTML = "";
    if(!state.drinks.length){
      list.innerHTML = '<div class="log-empty">Nothing logged yet today.</div>';
      return;
    }
    state.drinks.slice().reverse().forEach(function(d){
      var row = document.createElement("div");
      row.className = "log-row";
      row.innerHTML =
        '<span class="log-time">'+fmtTime(d.time)+'</span>'+
        '<span class="tile tile-sm tile-'+d.cat+'">'+iconSvg(d.icon)+'</span>'+
        '<span class="log-name">'+escapeHtml(d.name)+' <span class="log-mg">'+Math.round(d.mg)+' mg</span></span>';
      var del = document.createElement("button");
      del.className = "log-del"; del.innerHTML = "×"; del.setAttribute("aria-label","Remove");
      del.addEventListener("click", function(){ removeDrink(d.id); });
      row.appendChild(del);
      list.appendChild(row);
    });
  }
  function escapeHtml(s){
    var d = document.createElement("div"); d.textContent = s; return d.innerHTML;
  }

  // ---------- verdict + nudge ----------
  function renderVerdictAndNudge(current, hl){
    var bedtimeMs = todayAt(state.bedtime);
    if(bedtimeMs < Date.now()) bedtimeMs += 24*3600000;
    var atBedtime = levelAt(bedtimeMs, state.drinks, hl);
    var box = document.getElementById("ccVerdictBox");
    var text = document.getElementById("ccVerdictText");

    if(!state.drinks.length){
      text.innerHTML = "Log a drink to see your forecast for " + fmtTime(bedtimeMs) + ".";
      box.querySelector(".verdict-icon").textContent = "🌙";
    } else if(atBedtime <= state.threshold){
      text.innerHTML = "By <b>" + fmtTime(bedtimeMs) + "</b> you'll have ~<b>" + Math.round(atBedtime) + " mg</b> left — should be clear enough to fall asleep normally.";
      box.querySelector(".verdict-icon").textContent = "✅";
    } else {
      text.innerHTML = "By <b>" + fmtTime(bedtimeMs) + "</b> you'll likely still have ~<b>" + Math.round(atBedtime) + " mg</b> active — you may feel it a bit at bedtime.";
      box.querySelector(".verdict-icon").textContent = "⚠️";
    }

    var nudge = document.getElementById("ccTeaNudge");
    var hour = new Date().getHours();
    var showNudge = state.drinks.length > 0 && atBedtime > state.threshold && hour >= 12;
    nudge.classList.toggle("show", showNudge);
  }

  // ---------- master render ----------
  function renderAll(){
    var now = Date.now();
    var hl = halfLifeHours(state.profile);
    var current = levelAt(now, state.drinks, hl);
    var data = buildCurveData();
    var maxMg = 0;
    data.pts.forEach(function(p){ if(p.mg > maxMg) maxMg = p.mg; });
    var peak = Math.max(maxMg, current);

    var status = statusFor(current, state.threshold, peak);
    renderGauge(current, peak, status);
    document.getElementById("ccPeakVal").textContent = Math.round(peak) + " mg";
    document.getElementById("ccCupsVal").textContent = (current/95).toFixed(1).replace(/\.0$/,"") ;
    document.getElementById("ccHalflifeVal").textContent = hl.toFixed(1) + " hr";
    renderChart(data, maxMg);
    renderLog();
    renderVerdictAndNudge(current, hl);
    updateWhenPreview();
  }

  // ---------- share card ----------
  var modalBg = document.getElementById("ccModalBg");
  var shareImg = document.getElementById("ccShareImg");
  var lastBlob = null;

  function drawShareCard(cb){
    var canvas = document.createElement("canvas");
    var W = 640, H = 800, scale = 2;
    canvas.width = W*scale; canvas.height = H*scale;
    var ctx = canvas.getContext("2d");
    ctx.scale(scale,scale);

    ctx.fillStyle = "#f6f1e9"; ctx.fillRect(0,0,W,H);

    var now = Date.now(); var hl = halfLifeHours(state.profile);
    var current = levelAt(now, state.drinks, hl);
    var data = buildCurveData();
    var maxMg = 1; data.pts.forEach(function(p){ if(p.mg>maxMg) maxMg=p.mg; });
    var status = statusFor(current, state.threshold, Math.max(maxMg,current));
    var colorMap = { wired:"#af4a2c", winding:"#a5762f", clear:"#3f7fa0" };
    var labelMap = { wired:"Wired", winding:"Winding down", clear:"Clear" };
    var col = colorMap[status];

    document.fonts.ready.then(function(){
      ctx.fillStyle = "#5a4743";
      ctx.font = "700 13px Inter, sans-serif";
      ctx.fillText("CAFFEINE CLOCK", 40, 56);

      ctx.fillStyle = "#241a16";
      ctx.font = "italic 400 32px 'Cormorant Garamond', serif";
      ctx.fillText(new Date().toLocaleDateString(undefined,{weekday:"long", month:"short", day:"numeric"}), 40, 94);

      ctx.fillStyle = "#241a16";
      ctx.font = "600 96px 'IBM Plex Mono', monospace";
      ctx.fillText(Math.round(current)+"", 40, 212);
      ctx.font = "500 18px Inter, sans-serif";
      ctx.fillStyle = "#7a6a5e";
      ctx.fillText("mg active right now", 40, 238);

      ctx.fillStyle = col;
      roundRect(ctx, 40, 258, ctx.measureText(labelMap[status]).width+56, 34, 17);
      ctx.fill();
      ctx.fillStyle = "#ffffff";
      ctx.font = "700 14px Inter, sans-serif";
      ctx.fillText(labelMap[status].toUpperCase(), 62, 280);

      var sx = 40, sy = 342, sw = W-80, sh = 160;
      ctx.strokeStyle = "rgba(36,26,22,.10)"; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(sx, sy+sh); ctx.lineTo(sx+sw, sy+sh); ctx.stroke();
      var yMax = Math.max(maxMg*1.15, state.threshold*1.4, 40);
      ctx.beginPath();
      data.pts.forEach(function(p,i){
        var px = sx + (p.t-data.winStart)/(data.winEnd-data.winStart)*sw;
        var py = sy + sh - (p.mg/yMax)*sh;
        if(i===0) ctx.moveTo(px,py); else ctx.lineTo(px,py);
      });
      ctx.strokeStyle = "#5fa8cc"; ctx.lineWidth = 3; ctx.lineJoin="round"; ctx.lineCap="round"; ctx.stroke();
      ctx.lineTo(sx+sw, sy+sh); ctx.lineTo(sx, sy+sh); ctx.closePath();
      var g2 = ctx.createLinearGradient(0,sy,0,sy+sh);
      g2.addColorStop(0,"rgba(95,168,204,.28)"); g2.addColorStop(1,"rgba(95,168,204,.02)");
      ctx.fillStyle = g2; ctx.fill();
      var thY = sy + sh - (state.threshold/yMax)*sh;
      ctx.setLineDash([5,5]); ctx.strokeStyle = "#a5762f"; ctx.lineWidth = 1.5;
      ctx.beginPath(); ctx.moveTo(sx,thY); ctx.lineTo(sx+sw,thY); ctx.stroke();
      ctx.setLineDash([]);

      var bedtimeMs = todayAt(state.bedtime); if(bedtimeMs<now) bedtimeMs += 24*3600000;
      var atBed = levelAt(bedtimeMs, state.drinks, hl);
      ctx.fillStyle = "#7a6a5e"; ctx.font = "500 16px Inter, sans-serif";
      var verdictLine = (atBed<=state.threshold ? "Should be clear by " : "May still feel it at ") + fmtTime(bedtimeMs) + " (~"+Math.round(atBed)+" mg)";
      ctx.fillText(verdictLine, sx, sy+sh+42);

      ctx.strokeStyle = "rgba(36,26,22,.14)"; ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(40,H-92); ctx.lineTo(W-40,H-92); ctx.stroke();
      ctx.fillStyle = "#a79689"; ctx.font = "600 14px Inter, sans-serif";
      ctx.fillText("Know your own curve — track yours free", 40, H-58);
      ctx.fillStyle = "#5a4743"; ctx.font = "700 15px Inter, sans-serif";
      ctx.fillText("yourstore.com/pages/caffeine-clock", 40, H-32);

      canvas.toBlob(function(blob){ cb(canvas, blob); }, "image/png");
    });
  }
  function roundRect(ctx,x,y,w,h,r){
    ctx.beginPath();
    ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath();
  }

  document.getElementById("ccShareBtn").addEventListener("click", function(){
    drawShareCard(function(canvas, blob){
      lastBlob = blob;
      shareImg.src = canvas.toDataURL("image/png");
      modalBg.classList.add("show");
      if(navigator.share && navigator.canShare && blob){
        try{
          var file = new File([blob], "caffeine-clock.png", {type:"image/png"});
          if(navigator.canShare({files:[file]})){
            document.getElementById("ccShareApiBtn").style.display = "";
          }
        }catch(e){}
      }
    });
  });
  document.getElementById("ccModalClose").addEventListener("click", function(){ modalBg.classList.remove("show"); });
  modalBg.addEventListener("click", function(e){ if(e.target === modalBg) modalBg.classList.remove("show"); });
  document.getElementById("ccCopyImgBtn").addEventListener("click", function(){
    if(!lastBlob){ return; }
    try{
      navigator.clipboard.write([new ClipboardItem({"image/png": lastBlob})]).then(function(){
        var btn = document.getElementById("ccCopyImgBtn");
        var old = btn.textContent; btn.textContent = "Copied ✓";
        setTimeout(function(){ btn.textContent = old; }, 1800);
      });
    }catch(e){
      window.open(shareImg.src, "_blank");
    }
  });
  document.getElementById("ccShareApiBtn").addEventListener("click", function(){
    if(!lastBlob) return;
    var file = new File([lastBlob], "caffeine-clock.png", {type:"image/png"});
    navigator.share({ files:[file], title:"My caffeine clock" }).catch(function(){});
  });

  // ---------- boot ----------
  loadState();
  syncControlsFromState();
  updateLogButtonState();
  renderAll();
  setInterval(renderAll, 20000);

})();

  } catch(e) { console.error(e); }
})();
})();
